import { Link, useParams } from "react-router-dom";

export const ButtonUserBookEpisodeList = ({isEpisodeListPage, bookId})=>{
    const { school } = useParams();

    if(isEpisodeListPage)return null;

    return <Link className="btn" to={`/${school}/userbook/view/${bookId}`}><i className="fas fa-book"></i> 목록</Link>;

}